// extracted by mini-css-extract-plugin
module.exports = {"Grid":"App_Grid__2IDon","icon":"App_icon__2sTXs","Child":"App_Child__1S9Tv","tab-list-item":"App_tab-list-item__DfsLL","curtain":"App_curtain__Ibmgs"};